<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Páginas</h1>
    <div class="results" v-if="pages">
      <div class="results__element" v-for="(page, index) in pages" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="page.title"></h2>
          <p v-if="page.excerpt" class="results__text" v-text="page.excerpt"></p>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', page.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Página</button>
          <button @click.prevent="$parent.$emit('edit', page.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Página</button>
          <button @click.prevent="deletePage(page.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Pagina</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      pageId: null,
      pages: null,
      confirm: false
    }
  },
  created: function () {
    this.getPages()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getPages()
    },
    '$store.state.elementChanged': function () {
      this.getPages()
    }
  },
  methods: {
    getPages: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'pages'
      }
      this.get(httpRequest)
        .then(
          pages => {
            this.pages = pages.data
          }
        ).catch(
          () => {
            this.pages = null
          }
        )
    },
    deletePage: function (id) {
      this.confirm = true
      this.pageId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'pages'
      }
      this.delete(this.pageId, httpRequest)
        .then(
          response => {
            this.getPages()
            this.$store.commit('notificate', {
              title: 'PÁGINA BORRADA',
              text: 'La página ha sido borrada correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'PÁGINA NO BORRADA',
              text: 'No se pudo borrar la página seleccionada, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/list.vue